"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appIndexScenePaginationConfig = void 0;
var outline_1 = require("@heroicons/react/outline");
exports.appIndexScenePaginationConfig = {
    LeftIcon: outline_1.ChevronLeftIcon,
    RightIcon: outline_1.ChevronRightIcon,
};
